import { getCurrency } from './PricingUtils'

let _currency = null

export const currencyState = {
  getCurrency: (country) => {
    return _currency || getCurrency(country)
  },
  setCurrency: (currency) => {
    _currency = currency
  },
}
